import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '../src/theme/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primeicons/primeicons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/assets/css/style.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-responsive-pagination/themes/minimal.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';

import '../src/theme/theme.css';
import '../src/assets/css/style.css';
import '../src/components/common/navbar/navbar.css'
import '../src/components/pages/admin/transaction/supplierInvoice/invoice.css'
import '../src/components/pages/admin/admin-panel/settings/settings.css'
import '../src/components/pages/admin/transaction/onboarding/onboarding.css'
import '../src/components/pages/admin/transaction/purchaseOrder/purchaseOrder.css'
import '../src/components/pages/admin/transaction/productScanning/ProductScanningAdd.css'
import '../src/components/common/chat/chat.css'
import '../src/components/pages/vendor/auction/test.css'
import '../src/components/pages/auth/admin-login/login.css'
import '../src/components/pages/admin/main-master/finance-master/plantMaster/plant.css'
import '../src/components/pages/loader/loader.css';
import '../src/components/pages/admin/transaction/materialConsumption/matCons.css'
import '../src/components/pages/admin/Report/report.css'
import '../src/components/pages/admin/main-master/finance-master/assets/assets.css'
import '../src/components/pages/vendor/ltdc/AddLTDC.css'
import '../src/components/pages/admin/bid-management/auction/auction.css'
import '../src/components/pages/admin/inventory-mang/gatePass/gatePass.css'
import '../src/components/pages/admin/main-master/tender-master/tenMasPages/material/material.css'
import '../src/components/pages/admin/main-master/tender-master/tenMasPages/material/matPrint.css'
import '../src/components/pages/admin/main-master/finance-master/glAccount/glAccount.css'
import '../src/components/pages/auth/vendor-login/vendorLogin.css'
import '../src/components/pages/admin/transaction/matConApproval/approvalList.css'
import '../src/components/pages/admin/transaction/JournalVoucher/journalVoucher.css'
import '../src/components/pages/admin/inventory-mang/qualityRejection/qualityRejection.css'
import '../src/components/pages/admin/inventory-mang/InventoryVerification/inventoryVerification.css'
import { GlobalLoginDialog } from './components/pages/auth/popup-auth/GlobalLoginDialog'
import { getUserAllData } from './Constants';
import InvoiceView from './components/pages/admin/transaction/supplierInvoice/invoiceView.jsx';


// Lazy load all components
const PageNotFound = lazy(() => import('./components/pages/other-pages/PageNotFound'));
const PublicTokenHandler = lazy(() => import('./components/pages/other-pages/PublicTokenHandler'));
const Documents = lazy(() => import('./components/pages/other-pages/Documents'));
const Login = lazy(() => import('./components/pages/auth/admin-login/Login'));
const Callback = lazy(() => import('./components/pages/auth/admin-login/Callback'));
const Dashboard = lazy(() => import('./components/pages/admin/dashboard/Dashboard'));
const Dashboard_NKG = lazy(() => import('./components/pages/admin/dashboard/Dashboard_NKG'));
const MatConsList = lazy(() => import('./components/pages/admin/transaction/materialConsumption/MatConsList'));
const MatConsAdd = lazy(() => import('./components/pages/admin/transaction/materialConsumption/MatConsAdd'));
const ApprovalList = lazy(() => import('./components/pages/admin/transaction/matConApproval/ApprovalList'));
const TenderMasDashboard = lazy(() => import('./components/pages/admin/main-master/tender-master/TenderMasDashboard'));
const MaterialList = lazy(() => import('./components/pages/admin/main-master/tender-master/tenMasPages/material/MaterialList'));
const MaterialMaster = lazy(() => import('./components/pages/admin/main-master/tender-master/tenMasPages/material/MaterialMaster'));
const JournalVoucherAdd = lazy(() => import('./components/pages/admin/transaction/JournalVoucher/JournalVoucherAdd'));
const JournalVoucherList = lazy(() => import('./components/pages/admin/transaction/JournalVoucher/JournalVoucherList'));
const MailJournalVoucher = lazy(() => import('./components/pages/admin/transaction/JournalVoucher/MailJournalVoucher'));
const JVApprovalHeader = lazy(() => import('./components/pages/admin/transaction/JournalVoucher/JVApprovalHeader'));
const GenLedgerList = lazy(() => import('./components/pages/admin/main-master/finance-master/glAccount/GenLedgerList'));
const GenLedgerAdd = lazy(() => import('./components/pages/admin/main-master/finance-master/glAccount/GenLedgerAdd'));
const GenLedgerApproval = lazy(() => import('./components/pages/admin/main-master/finance-master/glAccount/GenLedgerApproval'));
const Cost = lazy(() => import('./components/pages/admin/main-master/finance-master/costCenter/Cost'));
const CostAdd = lazy(() => import('./components/pages/admin/main-master/finance-master/costCenter/CostAdd'));
const CostCenterApproval = lazy(() => import('./components/pages/admin/main-master/finance-master/costCenter/CostCenterApproval'));
const AuctionList = lazy(() => import('./components/pages/admin/bid-management/auction/AuctionList'));
const ReportDashboard = lazy(() => import('./components/pages/admin/Report/Report'));
const SettingDashboard = lazy(() => import('./components/pages/admin/admin-panel/settings/SettingDashboard'));
const CommonMaster = lazy(() => import('./components/pages/admin/admin-panel/settings/common/CommonMaster'));
const CommonRelation = lazy(() => import('./components/pages/admin/admin-panel/settings/common/CommonRelation'));
const WorkflowMatrix = lazy(() => import('./components/pages/admin/admin-panel/settings/common/WorkflowMatrix'));
const WorkflowList = lazy(() => import('./components/pages/admin/admin-panel/settings/common/WorkflowList'));
const ProductMail = lazy(() => import('./components/pages/admin/admin-panel/settings/material/ProductMail'));
const MatSection = lazy(() => import('./components/pages/admin/admin-panel/settings/material/MatSection'));
const ProductSection = lazy(() => import('./components/pages/admin/admin-panel/settings/material/ProductSection'));
const UserAssign = lazy(() => import('./components/pages/admin/admin-panel/settings/material/UserAssign'));
const ProductCatAssign = lazy(() => import('./components/pages/admin/admin-panel/settings/purchaseOrder/ProductCatAssign'));
const UserPlantAssign = lazy(() => import('./components/pages/admin/admin-panel/settings/qualityrejection/UserPlantAssign'));
const VendorLogin = lazy(() => import('./components/pages/auth/vendor-login/VendorLogin'));
const AddLTDC = lazy(() => import('./components/pages/vendor/ltdc/AddLTDC'));
const LandingPage = lazy(() => import('./Utils/LandingPage'));
const VendorDashboard = lazy(() => import('./components/pages/vendor/dashboard/VendorDashboard'));
const ListLTDC = lazy(() => import('./components/pages/vendor/ltdc/ListLTDC'));
const ApprovalDashboard = lazy(() => import('./components/pages/admin/Approval/ApprovalDashboard'));
const LtdcApproval = lazy(() => import('./components/pages/vendor/ltdc/LtdcApproval'));
const MsmeAdd = lazy(() => import('./components/pages/vendor/MSME/MsmeAdd'));
const MsmeList = lazy(() => import('./components/pages/vendor/MSME/MsmeList'));
const MsmeApproval = lazy(() => import('./components/pages/vendor/MSME/MsmeApproval'));
const VenCommInvList = lazy(() => import('./components/pages/vendor/venCommInv/VenCommInvList'));
const StockDeclarationList = lazy(() => import('./components/pages/vendor/stockDeclaration/StockDeclarationList'));
const StockDeclarationAdd = lazy(() => import('./components/pages/vendor/stockDeclaration/StockDeclarationAdd'));
const Decode = lazy(() => import('./components/pages/other-pages/Decode'));
const MaterialPrint = lazy(() => import('./components/pages/admin/main-master/tender-master/tenMasPages/material/MaterialPrint'));
const FinanceMasDashboard = lazy(() => import('./components/pages/admin/main-master/finance-master/FinanceMasDashboard'));
const PostingKey = lazy(() => import('./components/pages/admin/main-master/finance-master/postingKey/PostingKey'));
const Assets = lazy(() => import('./components/pages/admin/main-master/finance-master/assets/Assets'));
const Plant = lazy(() => import('./components/pages/admin/main-master/finance-master/plantMaster/Plant'));
const PlantAdd = lazy(() => import('./components/pages/admin/main-master/finance-master/plantMaster/PlantAdd'));
const AuctionAdd = lazy(() => import('./components/pages/admin/bid-management/auction/AuctionAdd'));
const VendorAuctionList = lazy(() => import('./components/pages/vendor/auction/VendorAuctionList'));
const MailGeneralLedger = lazy(() => import('./components/pages/admin/main-master/finance-master/glAccount/MailGeneralLedger'));
const Bidding = lazy(() => import('./components/pages/vendor/auction/Bidding'));
const MailCostCenter = lazy(() => import('./components/pages/admin/main-master/finance-master/costCenter/MailCostCenter'));
const JVPowerBI = lazy(() => import('./components/pages/admin/transaction/JournalVoucher/JVPowerBI'));
const TransDashBoard = lazy(() => import('./components/pages/admin/transaction/TransDashBoard'));
const Test = lazy(() => import('./components/pages/vendor/auction/Test'));
const GatePass = lazy(() => import('./components/pages/admin/inventory-mang/gatePass/GatePass'));
const Protected = lazy(() => import('./components/pages/other-pages/Protected'));
const CommInv = lazy(() => import('./components/pages/admin/transaction/commissionInvoice/CommInv'));
const Onboarding = lazy(() => import('./components/pages/admin/transaction/onboarding/Onboarding'));
const SupplierReg = lazy(() => import('./components/pages/admin/transaction/onboarding/SupplierReg'));
const SuppLandingPage = lazy(() => import('./components/pages/admin/transaction/onboarding/SuppLandingPage'));
const InventoryVerification = lazy(() => import('./components/pages/admin/inventory-mang/InventoryVerification/InventoryVerification'));
const QualityRejection = lazy(() => import('./components/pages/admin/inventory-mang/qualityRejection/QualityRejection'));
const Mapping = lazy(() => import('./components/pages/admin/main-master/mapping/Mapping'));
const Invoice = lazy(() => import('./components/pages/admin/transaction/supplierInvoice/Invoice'));
const InvoiceApproval = lazy(() => import('./components/pages/admin/transaction/supplierInvoice/InvoiceApproval'));
const PurchaseOrder = lazy(() => import('./components/pages/admin/transaction/purchaseOrder/PurchaseOrder'));
const PurchaseOrderApproval = lazy(() => import('./components/pages/admin/transaction/purchaseOrder/PurchaseOrderApproval'));
const ExpenseClaim = lazy(() => import('./components/pages/admin/otherPages/ExpenseClaim'));
const FormControl = lazy(() => import('./components/pages/admin/admin-panel/formControl/FormFieldControl'));
const ProjectBudget = lazy(() => import('./components/pages/admin/transaction/projectBudget/ProjectBudget'));
const ProductScanning = lazy(() => import('./components/pages/admin/transaction/productScanning/ProductScanning'));
const ForgotPassword = lazy(() => import('./components/pages/auth/forgot-password/ForgotPassword'));
const VerifyOtp = lazy(() => import('./components/pages/auth/forgot-password/VerifyOtp'));
const POBudget = lazy(() => import('./components/pages/admin/transaction/poBudget/POBudget'));
const Approval = lazy(() => import('./components/pages/admin/Approval/Approval'));
const Statement = lazy(() => import('./components/pages/vendor/vendorStatement/Statement'));
const BulkTPAPI = lazy(() => import('./components/pages/admin/admin-panel/BulkTPAPI'));
const KnowledgeHub = lazy(() => import('./components/pages/admin/knowledgeHub/KnowledgeHub'));
const KnowledgeHubPreview = lazy(() => import('./components/pages/admin/knowledgeHub/KnowledgeHubPreview'));
const InvoiceAlternateApproverUplo = lazy(() => import('./components/pages/admin/transaction/InvoiceAlternateApproverUpload'));
const OCR = lazy(() => import('./components/pages/admin/transaction/ocr/OCR'));
const InvoiceDashboard = lazy(() => import('./components/pages/admin/transaction/supplierInvoice/invoiceDashboard'));
const PODashboard = lazy(() => import('./components/pages/admin/transaction/supplierInvoice/podashboard'));
const SupplierDashboard = lazy(() => import('./components/pages/admin/transaction/supplierInvoice/supplierdashboard'));

// Define a fallback loading component
// const Loader = () => <div className="text-center mt-5">Loading...</div>;


export default function App() {
  const userAllData = getUserAllData();
  const decodeAllowedUsers = ['deepak', '10000125', '10000176'];
  const theme = process.env.REACT_APP_APPLICATION_CLIENT;
  useEffect(() => {
    const theme = process.env.REACT_APP_APPLICATION_CLIENT;
    document.documentElement.setAttribute('data-theme', theme);
  }, []);

  return (
    <>
      <Router>
        <Suspense fallback={<div />}>
          <Routes>
            <Route path="/*" element={<PageNotFound />} />
            {/* admin routes */}
            <Route path="/" element={<Login />}></Route>
            <Route path="/callback" element={<Callback />}></Route>
            <Route path="/:page/forgot-password" element={<ForgotPassword />}></Route>
            <Route path="/:page/otp-password" element={<VerifyOtp />}></Route>
            <Route path="/landing/:key" element={<LandingPage />} />
            {/* Conditional Dashboard Rendering */}
            {theme === 'Atomberg' ? (
              <Route
                path="/Admin/Dashboard/Index"
                element={
                  <Protected allowedRoles={['Admin']}>
                    <Dashboard />
                  </Protected>
                }
              />
            ) : (
              <Route path="/Admin/Dashboard/Index" element={<Dashboard_NKG />} />
            )}
            <Route path="/Admin/Masters/GroupMenu" element={<TransDashBoard />}></Route>
            <Route path="/Admin/Masters/InvoiceAlternateApproverUpload" element={<InvoiceAlternateApproverUplo />}></Route>
            {/*admin material consumption routes */}
            <Route
              path="/Admin/MaterialConsumption/List"
              element={
                <Protected allowedRoles={['Admin']}>
                  <MatConsList />{' '}
                </Protected>
              }
            />
            <Route
              path="/Admin/MaterialConsumption/Add"
              element={
                <Protected allowedRoles={['Admin']}>
                  <MatConsAdd />{' '}
                </Protected>
              }
            />
            <Route
              path="/Admin/MaterialConsumption/ApprovalList"
              element={
                <Protected allowedRoles={['Admin']}>
                  <ApprovalList />{' '}
                </Protected>
              }
            />
            {/*admin material master routes */}
            <Route
              path="/Admin/Masters/Material"
              element={
                <Protected allowedRoles={['Admin']}>
                  <MaterialList />{' '}
                </Protected>
              }
            />
            <Route
              path="/Admin/Masters/AddMaterial"
              element={
                <Protected allowedRoles={['Admin']}>
                  <MaterialMaster />{' '}
                </Protected>
              }
            />
            <Route
              path="/material-print/:id/:reqno"
              element={
                <Protected allowedRoles={['Admin']}>
                  <MaterialPrint />{' '}
                </Protected>
              }
            />
            <Route
              path="/Admin/Masters/TenderMaster"
              element={
                <Protected allowedRoles={['Admin']}>
                  <TenderMasDashboard />{' '}
                </Protected>
              }
            />
            {/*admin finance master routes */}
            <Route path="/Admin/Masters/FinanceMaster" element={<FinanceMasDashboard />} />
            <Route path="/Admin/Masters/FinanceMaster/PostingKey" element={<PostingKey />} />
            <Route path="/Admin/Masters/FinanceMaster/Assets" element={<Assets />} />
            <Route path="/Admin/Masters/FinanceMaster/Plant" element={<Plant />} />
            <Route path="/Admin/Masters/FinanceMaster/AddPlant" element={<PlantAdd />} />

            {/*admin mapping routes */}
            <Route path="/Admin/Masters/Mapping/*" element={<Mapping />} />

            {/* admin commission invoice routes */}
            <Route
              path="/Admin/Commission/:page"
              element={
                <Protected allowedRoles={['Admin']}>
                  <CommInv />{' '}
                </Protected>
              }
            />

            {/* admin jurnal voucher routes */}
            <Route
              path="/Admin/JournalVoucher/List"
              element={
                <Protected allowedRoles={['Admin']}>
                  <JournalVoucherList />{' '}
                </Protected>
              }
            />
            <Route
              path="/Admin/JournalVoucher/Add"
              element={
                <Protected allowedRoles={['Admin']}>
                  <JournalVoucherAdd />{' '}
                </Protected>
              }
            />
            <Route
              path="/Admin/MailApprovalPop"
              element={
                <Protected allowedRoles={['Admin']}>
                  <MailJournalVoucher />{' '}
                </Protected>
              }
            />
            <Route
              path="/Admin/JournalVoucher/ApprovalListHeader"
              element={
                <Protected allowedRoles={['Admin']}>
                  <JVApprovalHeader />{' '}
                </Protected>
              }
            />
            <Route
              path="/Admin/JournalVoucher"
              element={
                <Protected allowedRoles={['Admin']}>
                  <JVPowerBI />{' '}
                </Protected>
              }
            />

            {/* supplier invitation routes */}
            <Route path="/Admin/Onboarding/:page" element={<Onboarding />} />
            <Route
              path="/Vendor/Onboarding/SupplierRegistration"
              element={
                <Protected allowedRoles={['Admin', 'Vendor']}>
                  <SupplierReg />{' '}
                </Protected>
              }
            />
            <Route path="/Vendor/Landing/index" element={<SuppLandingPage />} />

            {/* inventory managment routes */}
            <Route path="/Admin/InventoryManagement/GatePass/:page" element={<GatePass />} />

            {/* inventory verification routes */}
            <Route path="/Admin/InventoryManagement/InventoryVerification/:page" element={<InventoryVerification />} />

            {/* quality rejection routes */}
            <Route path="/Admin/InventoryManagement/QualityRejection/:page" element={<QualityRejection />} />

            {/* auction routes */}
            <Route path="/Admin/Auction/AuctionList" element={<AuctionList />} />
            <Route path="/Admin/Auction/AuctionAdd" element={<AuctionAdd />} />

            {/* general ledger routes */}
            <Route path="/Admin/Masters/FinanceMaster/GeneralLedgerList" element={<GenLedgerList />} />
            <Route path="/Admin/Masters/FinanceMaster/GeneralLedgerAdd" element={<GenLedgerAdd />} />
            <Route path="/Admin/Masters/FinanceMaster/GeneralLedgerApproval" element={<GenLedgerApproval />} />
            <Route path="/Admin/MailGeneralLedger" element={<MailGeneralLedger />} />

            {/* Cost Center routes */}
            <Route path="/Admin/Masters/FinanceMaster/Cost" element={<Cost />} />
            <Route path="/Admin/Masters/FinanceMaster/AddCost" element={<CostAdd />} />
            <Route path="/Admin/Masters/FinanceMaster/CostCenterApproval" element={<CostCenterApproval />} />
            <Route path="/Admin/MailCostCenter" element={<MailCostCenter />} />

            {/* admin report routes */}
            <Route path="/Admin/Report/:page" element={<ReportDashboard />} />

            {/* admin approval routes */}
            <Route path="/Admin/Approval/:page" element={<Approval />} />
            <Route path="/Admin/Approval/Index" element={<ApprovalDashboard />} />

            {/* vendor invoice routes */}
            <Route path="/Vendor/Invoice/:page" element={<Invoice />} />
            <Route path="/Vendor/Invoice/View/:id" element={<InvoiceView />} />
            <Route
              path="/Admin/Invoice/Dashboard"
              element={
                <Protected allowedRoles={['Admin']}>
                  <InvoiceDashboard />
                </Protected>
              }
            />
            <Route
              path="/Admin/PO/Dashboard"
              element={
                <Protected allowedRoles={['Admin']}>
                  <PODashboard />
                </Protected>
              }
            />
            <Route
              path="/Admin/SupplierReg/Dashboard"
              element={
                <Protected allowedRoles={['Admin']}>
                  <SupplierDashboard />
                </Protected>
              }
            />
            <Route
              path="/Admin/Invoice/Approval"
              element={
                <Protected allowedRoles={['Admin']}>
                  {' '}
                  <InvoiceApproval />
                </Protected>
              }
            />

            {/* purchase order routes */}
            <Route path="/Vendor/PurchaseOrder/:page" element={<PurchaseOrder />} />
            <Route
              path="/Admin/PurchaseOrder/Approval"
              element={
                <Protected allowedRoles={['Admin']}>
                  {' '}
                  <PurchaseOrderApproval />
                </Protected>
              }
            />

            {/* project budget routes */}
            <Route path="/Admin/ProjectBudget/:page" element={<ProjectBudget />} />

            {/* product Scanning routes */}
            <Route path="/Admin/ProductScanning/:page" element={<ProductScanning />} />

            {/* setting routes */}
            <Route path="/Admin/Masters/Setting" element={<SettingDashboard />} />
            <Route path="/Admin/Admin-Panel/Settings/CommonMaster" element={<CommonMaster />} />
            <Route path="/Admin/Admin-Panel/Settings/CommonRelation" element={<CommonRelation />} />
            <Route path="/Admin/Admin-Panel/Settings/WorkflowMatrix" element={<WorkflowMatrix />} />
            <Route path="/Admin/Admin-Panel/Settings/WorkflowList" element={<WorkflowList />} />
            <Route path="/Admin/Admin-Panel/Settings/ProductMail" element={<ProductMail />} />
            <Route path="/Admin/Admin-Panel/Settings/MaterialSection" element={<MatSection />} />
            <Route path="/Admin/Admin-Panel/Settings/ProductSection" element={<ProductSection />} />
            <Route path="/Admin/Admin-Panel/Settings/UserAssignment" element={<UserAssign />} />
            <Route path="/Admin/Admin-Panel/Settings/ProductCategoryAssignment" element={<ProductCatAssign />} />
            <Route path="/Admin/Admin-Panel/Settings/PurchaseOrderBudget" element={<POBudget />} />
            <Route path="/Admin/Admin-Panel/Settings/UserPlantAssignment" element={<UserPlantAssign />} />
            <Route path="/Admin/Admin-Panel/BulkTPAPIConsumption" element={<BulkTPAPI />} />

            {/* knowledge hub route */}
            <Route path="/Admin/KnowledgeHub" element={<KnowledgeHub />} />
            <Route path="/Admin/KnowledgeHub/Preview" element={<KnowledgeHubPreview />} />

            {/* admin form control routes */}
            <Route
              path="/Admin/Masters/:page"
              element={
                <Protected allowedRoles={['Admin']}>
                  <FormControl />
                </Protected>
              }
            />

            <Route
              path="/Admin/ExpenseClaim"
              element={
                <Protected allowedRoles={['Admin']}>
                  <ExpenseClaim />{' '}
                </Protected>
              }
            />

            {/* vendor routes */}
            <Route path="/Vendor" element={<VendorLogin />} />
            <Route
              path="/Vendor/Dashboard/Index"
              element={
                <Protected allowedRoles={['Vendor']}>
                  <VendorDashboard />{' '}
                </Protected>
              }
            />

            {/* vendor statements routes */}
            <Route
              path="/Vendor/VendorStatement/Statement"
              element={
                <Protected allowedRoles={['Vendor', 'Admin']}>
                  <Statement />{' '}
                </Protected>
              }
            />

            {/* vendor ltdc routes */}
            <Route path="/Vendor/LTDC/List" element={<ListLTDC />} />
            <Route path="/Vendor/LTDC/Add" element={<AddLTDC />} />
            <Route path="/Admin/LTDC/LTDCApporval" element={
              <Protected allowedRoles={['Admin']}>
                <LtdcApproval />{' '}
              </Protected>
            } />


            {/* vendor msme routes */}
            <Route path="/Vendor/MSME/List" element={<MsmeList />} />
            <Route path="/Vendor/MSME/Add" element={<MsmeAdd />} />
            <Route path="/Admin/MSME/MSMEApporval" element={
              <Protected allowedRoles={['Admin']}>
                <MsmeApproval />{' '}
              </Protected>
            } />


            {/* vendor commission invoice routes */}
            <Route path="/Vendor/CommissionInvoice/List" element={<VenCommInvList />} />

            {/* stock declaration routes */}
            <Route path="/Vendor/StockDeclaration/List" element={<StockDeclarationList />} />
            <Route path="/Vendor/StockDeclaration/Add" element={<StockDeclarationAdd />} />
            <Route path={decodeAllowedUsers.includes(userAllData?.[0]?.userId) ? '/decode' : '/*'} element={<Decode />} />

            {/* vendor auction routes */}
            <Route path="/Vendor/Auction/View" element={<VendorAuctionList />} />
            <Route path="/Vendor/Auction/Bid" element={<Bidding />} />
            <Route path="/vendor/test" element={<Test />} />

            <Route path="/Admin/OCR" element={
              <Protected allowedRoles={['Admin']}>
                <OCR />
              </Protected>
            } />
          </Routes>
        </Suspense>
        {/* </Suspense> */}
      </Router>
    </>
  );
}
